import React from "react"

function BlogByTag({ data, pageContext }) {
  const { previousPagePath } = pageContext
  const tag = data.ghostTag

  return (
    <>
      {!previousPagePath && (
        <>
          <div className="max-w-sm mx-auto md:max-w-none  text-center md:text-left">
            <h1 className="h1" data-aos="fade-down">
              {tag.name}
            </h1>

            <div
              className="text-gray-400 text-lg pb-6 mt-5 mb-10 border-b border-gray-700"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              {tag.description
                ? tag.description
                : `A collection of ${tag.count.posts} posts`}
            </div>
          </div>
        </>
      )}

      {previousPagePath && (
        <div
          className="max-w-3xl mx-auto text-center pb-12 md:pb-16"
          data-aos-id-blog
        >
          <h1
            className="h2 mb-4 capitalize"
            data-aos="fade-up"
            data-aos-anchor="[data-aos-id-blog]"
          >
            {data.ghostTag.name}
          </h1>
        </div>
      )}
    </>
  )
}

export default BlogByTag
